import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "@environments/environment";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Allocation } from "@interfaces/allocation.interface";
import { ClientLocation } from "@interfaces/clientLocation.interface";
import { Client } from "@interfaces/models/client.interface";
import { FirewallLog } from "@interfaces/models/firewallLog.interface";
import { FirewallLogFailureReason } from "@interfaces/models/firewallLogFailureReason.interface";
import { Part } from "@interfaces/models/part.interface";
import { Project } from "@interfaces/project.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AllocationService } from "@services/allocation.service";
import { AllocationWorkOrderService } from "@services/allocationWorkOrder.service";
import { ClientService } from "@services/client.service";
import { ClientLocationService } from "@services/clientLocation.service";
import { FileService } from "@services/file.service";
import { FirewallLogService } from "@services/firewallLog.service";
import { FirewallLogFailureReasonService } from "@services/firewallLogFailureReason.service";
import { NonConformanceReportService } from "@services/nonConformanceReport.service";
import { PartService } from "@services/part.service";
import { ProjectService } from "@services/project.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "firewallLogs-id",
	styleUrls: ["firewallLogs-id.css"],
	templateUrl: "firewallLogs-id.html"
})
export class FirewallLogsIdAdminComponent {
	allocation: Allocation = new Allocation();
	allocationWorkOrders: any[] = [];
	allocations: Allocation[] = [];
	areasOfIssue: string[] = [
		"CAD Issue",
		"Health and Safety",
		"Issue Found at Customer",
		"Maintenance Issue",
		"Person / Training Issue",
		"Process wrong",
		"Process - Assembly",
		"Process - 5 Axis Issue",
		"Process - Flat Laser issue",
		"Process - Goods-In",
		"Process - Press Issue",
		"Process - Press Brake issue",
		"Process - Weld Issue",
		"Process - Spot Weld Issue",
		"Process - Kingsland Issue",
		"Process - Fab/Deburr Issue",
		"Process - Firewall Issue",
		"Process - Logistics issue",
		"Process - Quality Issue",
		"Process - Toolroom",
		"Supplier - Material Issue",
		"Supplier - Outsource Issue",
	];
	clientLocations: ClientLocation[] = [];
	clients: Client[] = [];
	failureReasons: FirewallLogFailureReason[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	imageStyle = "";
	item: FirewallLog = new FirewallLog();
	itemId = 0;
	itemType = "Firewall Log";
	mode = "";
	parts: Part[] = [];
	projects: Project[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title: string = "View " + this.itemType;
	userProfiles: UserProfile[] = [];
	
	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private allocationService: AllocationService, private allocationWorkOrderService: AllocationWorkOrderService, private clientLocationService: ClientLocationService, private clientService: ClientService, private firewallLogFailureReasonService: FirewallLogFailureReasonService, private fileService: FileService, private itemService: FirewallLogService, private nonConformanceReport: NonConformanceReportService, private partService: PartService, private projectService: ProjectService, private userProfileService: UserProfileService) {
		this.getAllocations();
		this.getClientLocations();
		this.getClients();
		this.getFailureReasons();
		this.getParts();
		this.getPeople();
		this.getProjects();

		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.getItem(params.id.split("_")[0], "edit");
					this.edit();
				} else {
					this.getItem(params.id, "view");
				}
			} else {
				this.create();
			}
		});

		this.uploadImage = this.uploadImage.bind(this);
		this.viewNonConformanceReport = this.viewNonConformanceReport.bind(this);
		this.viewWorkOrder = this.viewWorkOrder.bind(this);
	}

	buildButtons(mode: string) {
		this.mode = mode;
		this.headerPrimaryButtons = [];
		this.headerSecondaryButtons = [];
		this.headerTertiaryButtons = [];

		if (mode == "edit") {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "Cancel" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create") {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
			if (this.item.nonConformanceReportId != undefined && this.item.nonConformanceReportId > 0) {
				this.headerSecondaryButtons = [
					{ method: "viewNonConformanceReport", text: "View NCR" }
				];
			} else {
				this.headerSecondaryButtons = [
					{ method: "createNonConformanceReport", text: "Create NCR" }
				];
			}
		}
	}

	cancelEditing() {
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		if (this.mode === "view" || confirm("Are you sure you wish to leave the page? Unsaved changes will be discarded.")) {
			this.router.navigate([`/${this.returnUrl}/`]);
		}
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Added New " + this.itemType);
					this.item = new FirewallLog();
					this.mode = "view";
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createNonConformanceReport() {
		if (this.item.nonConformanceReportId != undefined && this.item.nonConformanceReportId > 0) {
			return;
		}
		if (confirm("Are you sure you wish to create an NCR for this log?") == false) {
			return;
		}
		this.itemService.createNonConformanceReport(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Created NCR");
					this.getItem(this.item.lookupId, this.mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "allocation":
				{
					if (args.value !== undefined && args.value !== null) {
						const allocation = this.allocations.filter((a: Allocation) => a.id == args.value);
						this.item.partId = allocation[0].partId;
						
						const part = this.parts.filter((p: Part) => p.id == this.item.partId);
						this.item.clientId = part[0].clientId;
						this.item.projectId = part[0].projectId;
					}
				}
				break;
		}
	}
	
	getAllocation(id: number) {
		this.allocationService.getSingleById(id)
			.subscribe(
				(res: any) => {
					this.allocation = res.response;
					this.getAllocationWorkOrders(id);
				},
				(err) => console.log(err)
			);
	}

	getAllocationWorkOrders(id: number) {
		this.allocationWorkOrderService.forAllocation(id)
			.subscribe(
				(res: any) => {
					this.allocationWorkOrders = res.response;
				},
				(err) => console.log(err)
			);
	}

	getAllocations() {
		this.allocationService.getAll()
			.subscribe(
				(res: any) =>  {
					this.allocations = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getClientLocations() {
		this.clientLocationService.getAll()
			.subscribe(
				(res: any) => {
					this.clientLocations = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) => {
					this.clients = res.response.items;
					this.clients.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getFailureReasons() {
		this.firewallLogFailureReasonService.allActive()
			.subscribe(
				(res: any) => {
					this.failureReasons = res.response;
					this.failureReasons.sort((a,b) => a.reason.localeCompare(b.reason));
				},
				(err) => console.log(err)
			);
	}

	getItem(lookupId: Guid, mode: string) {
		this.itemService.getSingleByLookupId(lookupId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.setImageStyle(this.item.imageUrl);
					this.buildButtons(mode);
					if (this.item.allocationId) {
						this.getAllocation(this.item.allocationId);
					}
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
	
	getParts() {
		this.partService.getAll()
			.subscribe(
				(res: any) =>  {
					this.parts = res.response.items;
					this.parts.sort((a,b) => a.partNumber.localeCompare(b.partNumber));
				},
				(err) => console.log(err)
			);
	}
	
	getPeople() {
		this.userProfileService.getActiveUsers()
			.subscribe(
				(res: any) =>  {
					this.userProfiles = res.response;
					this.userProfiles.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}
	
	getProjects() {
		this.projectService.getAll()
			.subscribe(
				(res: any) =>  {
					this.projects = res.response.items;
					this.projects.sort((a,b) => a.displayName.localeCompare(b.displayName));
				},
				(err) => console.log(err)
			);
	}
	
	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	setImageStyle(imageUrl: string) {
		this.imageStyle = `background-image: url("${imageUrl}")`;
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	uploadImage(file: File) {
		const containerName = "images";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		uploadData.append("mimeTypeKey", "ImageMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.item.imageUrl = `${environment.server.storageUrl}/${containerName}/${res.response[0].location}`;
					this.setImageStyle(this.item.imageUrl);
					this.toastService.success("Image uploaded - Click Save to confirm change");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Image Upload Failed - Please ensure you are uploading a valid image file");
				}
			);
	}

	viewNonConformanceReport() {
		if (this.item.nonConformanceReportId == undefined) {
			return;
		}
		this.nonConformanceReport.getSingleById(this.item.nonConformanceReportId)
			.subscribe(
				(res: any) => {
					const ncr = res.response;
					this.router.navigate([`admin/nonConformanceReports/${ncr.lookupId}`]);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	viewWorkOrder(e: any) {
		this.router.navigate([`admin/workOrders/${e.row.data.workOrderId}`]);
	}
}